export const INITIAL_REQUEST_FILTER = {
    page: 1,
    limit: 20,
    offset: 0
}

export const INITIAL_PARENT_REQUEST_FILTER = {
    page: 1,
    limit: 10,
    offset: 0
}

export enum POST_STATUS {
    active = 0,
    deleted = 1
}

export enum COMMENT_NOTIF_TYPE {
    add = 3
}

export enum COMMENT_EDIT_MODE {
    add = 'add',
    edit = 'edit',
    answer = 'answer'
}export const INITIAL_REQUEST_FILTER = {
    page: 1,
    limit: 20,
    offset: 0
}

export const INITIAL_PARENT_REQUEST_FILTER = {
    page: 1,
    limit: 10,
    offset: 0
}

export enum POST_STATUS {
    active = 0,
    deleted = 1
}

export enum COMMENT_NOTIF_TYPE {
    add = 3
}

export enum COMMENT_EDIT_MODE {
    add = 'add',
    edit = 'edit',
    answer = 'answer'
}